<div class="emoji-preview-wrapper">
  <ngx-emoji [emoji]="selectedEmoji" size="16" class="custom-emoji"></ngx-emoji>
</div>
